<!-- Add/Edit Article Modal -->
<div class="modal fade" id="editAd" tabindex="-1" aria-labelledby="editAd" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="editAdTitle">Edit Ad</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
               <!-- <div class="row">
                    <div class="col-12 mb-3">
                        <label for="articleTitle" class="form-label">Article Title</label>
                        <input type="text" class="form-control" id="articleTitle" placeholder="Article Title">
                    </div>
                </div> -->
                <div class="row">
                    <div class="col-12 mb-3">
                        <label for="adImg" class="form-label">Upload New Advertisement</label>
                        <input (change)="updateAdImageFile($event.target.files)" class="form-control" type="file" id="adImg">
                    </div>
                </div>
                <!--<div class="row">
                    <div class="col-12 mb-3">
                        <label for="articleContent" class="form-label">Article Content</label>
                        <textarea class="form-control" id="articleContent" rows="10"></textarea>
                    </div>
                </div>-->
            </div>
            <div class="modal-footer">
                <button type="button" (click)="submitUpdatedAd()" class="btn btn-sb border-lb text-strong text-uppercase m-100">Save</button>
                <button type="button" class="btn btn-cancel text-strong text-uppercase m-100" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>


<section class="page-container">

    <div class="container-fluid ptCustom">

        <div class="my-2">
            <a [routerLink]="['/admin-portal/chamber/pending-ads']" class="text-white"><i class="fa-regular fa-angle-left"></i> back to all pending ads</a>
        </div>

        <div class="row">

            <div class="col-lg-8 col-md-8 my-2">
                <div class="card shadow-sm rounded-lg">
                    <div class="card-body p-4">
                        <div class="detailsContainer">
                            <div class="detailsHeader">
                                <h4>Member Advertisement</h4>
                                <div class="d-flex align-items-center justify-content-end" *ngIf="!ad.isClosed">
                                    <a (click)="CommonLibrary.downloadImageByUrl(ad.imageUrl,ad.memberCompany + '_Ad_' + CommonLibrary.formatDateIntoString(ad.submissionDate))" class="me-3"><i class="fa-regular fa-download"></i></a>
                                    <a href="javascript:void(0);" (click)="resetModal()" data-bs-toggle="modal" data-bs-target="#editAd" *ngIf="!ad.isClosed"><i class="fa-regular fa-pencil"></i></a>
                                </div>
                            </div>
                            <div class="detailsSection">
                                <div class="row">
                                    <div class="col">
                                        <div class="detailsBlock introLetterContent">
                                            <div class="pendingNewsPhotoContainer">
                                                <img [src]="ad.imageUrl" alt="featured image" class="pendingNewsPhotoImg"/>
                                            </div>
                                            <p>
                                                <span class="d-block fw-bold">Ad Url</span>
                                                {{ ad.url }}
                                            </p>
                                            <p>
                                                <span class="d-block fw-bold">Date to Run</span>
                                                {{ ad.runDate }}
                                            </p>
                                            <p>
                                                <span class="d-block fw-bold">Notes from Member</span>
                                                {{ ad.memberNotes }}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>



                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-4 my-2">
                <div class="card shadow-sm rounded-lg">
                    <div class="card-body p-4">
                        <div class="detailsContainer">
                            <div class="detailsHeader justify-content-center">
                                <h4>Review Letter</h4>
                            </div>
                            <div class="detailsSection">
                                <div class="detailsBlock">
                                    <div class="dataLabel">
                                        <span>Member</span>
                                    </div>
                                    <div class="dataOutput">
                                        <span class="d-block">{{ ad.memberName }}</span>
                                        <small class="text-muted">{{ ad.memberCompany }}</small>
                                    </div>
                                </div>

                                <div class="detailsBlock">
                                    <div class="dataLabel">
                                        <span>Previous Ad Submissions</span>
                                    </div>
                                    <div class="dataOutput">
                                        <span class="d-block">{{ ad.numberOfSubmissions}} Total </span>
                                        <small *ngIf="ad.numberOfSubmissions > 0" class="text-muted fst-italic">last on {{CommonLibrary.formatDateIntoString(ad.mostRecentSubmission)//getDate(ad.mostRecentSubmission)}}</small>
                                    </div>
                                </div>
                                <div *ngIf="!ad.isClosed">
                                    <div class="mb-3">
                                        <input [(ngModel)]="ad.approverNotes" type="text" class="form-control" id="exampleNotes" placeholder="Notes">
                                    </div>
                                    <div class="mb-4">
                                        <a href="javascript:void(0);" (click)="UpdateStatus(1)" type="button" class="btn btn-add text-strong hvr-grow w-100"><i class="fa-solid fa-check"></i> approve ad</a>
                                    </div>
                                    <div class="text-center">
                                        <a href="javascript:void(0);" (click)="UpdateStatus(2)" class="text-white"><small>reject ad</small></a>
                                    </div>
                                </div>

                                <div *ngIf="ad.isClosed">
                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Status</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span class="d-block">{{ad.statusString}}</span>
                                        </div>
                                    </div>

                                    <div class="detailsBlock">
                                        <div class="dataLabel">
                                            <span>Notes</span>
                                        </div>
                                        <div class="dataOutput">
                                            <span class="d-block">{{ad.approverNotes}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>



</section>
